const SOL = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="black"
    />
    <path
      d="M5.11268 5.12734C5.19222 5.04579 5.30007 5 5.41252 5H15.7875C15.9765 5 16.0711 5.23443 15.9374 5.37148L13.8873 7.47269C13.8078 7.55421 13.6999 7.6 13.5875 7.6H3.21252C3.02353 7.6 2.92892 7.36557 3.06259 7.22855L5.11268 5.12734Z"
      fill="url(#paint0_linear_2899_4559)"
    />
    <path
      d="M5.11268 12.9273C5.19222 12.8458 5.30007 12.8 5.41252 12.8H15.7875C15.9765 12.8 16.0711 13.0344 15.9374 13.1715L13.8873 15.2727C13.8078 15.3542 13.6999 15.4 13.5875 15.4H3.21252C3.02353 15.4 2.92892 15.1656 3.06259 15.0285L5.11268 12.9273Z"
      fill="url(#paint1_linear_2899_4559)"
    />
    <path
      d="M13.5875 8.90002C13.6999 8.90002 13.8078 8.94582 13.8873 9.02734L15.9374 11.1285C16.0711 11.2656 15.9765 11.5 15.7875 11.5H5.41252C5.30007 11.5 5.19222 11.4542 5.11268 11.3727L3.06259 9.27147C2.92892 9.13445 3.02353 8.90002 3.21252 8.90002H13.5875Z"
      fill="url(#paint2_linear_2899_4559)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2899_4559"
        x1="11.7888"
        y1="2.1335"
        x2="4.31719"
        y2="16.0851"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00FFA3" />
        <stop offset="1" stop-color="#DC1FFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2899_4559"
        x1="11.7888"
        y1="2.13355"
        x2="4.31719"
        y2="16.0851"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00FFA3" />
        <stop offset="1" stop-color="#DC1FFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2899_4559"
        x1="11.7888"
        y1="2.13352"
        x2="4.31719"
        y2="16.0851"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00FFA3" />
        <stop offset="1" stop-color="#DC1FFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SOL;
